<div class="min-w-0 space-y-3">
  <div class="min-w-0">
    <label class="mb-1 block text-sm font-medium !text-slate900">
      {{ questionLabel }}
      @if (required) {
        <span class="text-red600">*</span>
      }
    </label>

    <div
      class="question-display min-h-10 w-full rounded-md border border-indigo300 bg-indigo50 px-3 py-2 text-[14px] leading-5 text-slate900"
      [attr.aria-label]="questionLabel"
      >
      {{ questionText }}
    </div>
  </div>

  <app-input-reusable
    [label]="commentLabel"
    type="textarea"
    size="md"
    [placeholder]="commentPlaceholder || ''"
    [control]="commentControl"
    [required]="required"
    [externalErrorMessage]="commentErrorMessage"
  ></app-input-reusable>

  @if (maxCommentLength) {
    <p class="text-xs text-slate400 text-right">
      {{ commentCount }} / {{ maxCommentLength }}
    </p>
  }
</div>
